export const LicenseStylesColums = {
  buttonContainer: {
    display: "flex",
    alignItems: "left",
    gap: 0.5,
    justifyContent: "left",
    width: "100%",
  },
  statusColors: {
    all: {
      color: "#757575",
      bg: "#f5f5f5",
    },
    active: {
      color: "#4CAF50",
      bg: "#e7f4dc",
    },
    unassigned: {
      color: "#3478F6",
      bg: "#a3caf4",
    },
    upcoming: {
      color: "#7A58C1",
      bg: "#E0D3E8",
    },
    expired: {
      color: "#B71C1C",
      bg: "#d58884",
    },
  },
};
